import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import * as _ from 'lodash';
import {UserPrivilegeService} from '../../../../services/common/user-privilege/user-privilege.service';

@Component({
  selector: 'offline-connections-dialog',
  templateUrl: './offline-connections-dialog.component.html',
  styleUrls: ['./offline-connections-dialog.component.scss']
})
export class OfflineConnectionsDialogComponent implements OnInit {

  connection: any;

  onApply = new EventEmitter();
  onCancel = new EventEmitter();
  isEditMode: boolean;
  isSrcNodeIsThirdParty = false;
  isDestNodeIsThirdParty = false;
  isSrcNodeSupportsTeams = false;
  isDestNodeSupportsTeams = false;
  selectedSrcNode = null;
  selectedDestNode = null;
  isSipGroupNameMandatory = false;

  title;
  isAuthorized: boolean;

  advancedConditions: any;
  useGlobalAdvancedCondition;

  scopeObj: any = {};

  transportProtocolOptions = [
    { value: 'UDP', text: 'UDP' },
    { value: 'TCP', text: 'TCP' },
    { value: 'TLS', text: 'TLS' }
  ];

  operStateOptions: any[] = [{text: 'AVAILABLE', value: 'AVAILABLE'}, {text: 'UNAVAILABLE', value: 'UNAVAILABLE'}];
  qualityOptions: any[] = [{text: 'UNKNOWN', value: 'UNKNOWN'}, {text: 'BAD', value: 'BAD'},
    {text: 'FAIR', value: 'FAIR'}, {text: 'GOOD', value: 'GOOD'}];

  options: any = {};


  constructor(public dialogRef: MatDialogRef<OfflineConnectionsDialogComponent>,
              private userPrivilege: UserPrivilegeService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.connection = data.selectedItem;
  }

  ngOnInit(): void {
    this.isEditMode = this.data.isEditMode;
    this.isAuthorized  = this.userPrivilege.isAuthorized();
    this.title = `${this.isEditMode ? 'Edit' : 'Add'} Offline Connection`;

    this.isSrcNodeIsThirdParty = false;
    this.isDestNodeIsThirdParty = false;

    if (this.data.isEditMode) {
      this.editConnectionInitialization();
    } else {
      this.addConnectionInitialization();
    }
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    if (this.isEditMode) {
      this.constructConnectionForEdit();
    } else {
      this.constructConnectionForAdd();
    }

    this.onApply.emit(this.connection);
  }

  private addConnectionInitialization(): void {
    this.scopeObj.name = this.connection.name;
    this.scopeObj.transportType = 'TCP';
    this.isEditMode = false;
    this.data.routingInterface = this.data.routingInterface.filter((rI) => {
      return rI.operativeState !== 'PREDELETED';
    });
    this.scopeObj.selectedSrcNode = this.connection.srcNode;
    this.scopeObj.selectedDestNode = this.connection.destNode;
    this.scopeObj.weight = 50;
    this.scopeObj.shouldSync = true;
    this.scopeObj.srcSipGroupName = '';
    this.scopeObj.destSipGroupName = '';
    this.updateSrcNodeOptions();
    this.updateSrcRIOptions();
    this.updateDestNodeOptions();
    this.updateDestRIOptions();
    this.updateEdgesName();
    this.updateSrcNodeData(this.connection.srcNode);
    this.updateDestNodeData(this.connection.destNode);
    this.updateIpProfilesAndMediaRealm();
    this.setDefaultIpProfile();
  }

  private editConnectionInitialization(): void {
    this.isEditMode = true;
    this.scopeObj.name = this.connection.name;
    this.scopeObj.weight = this.connection.weight;
    this.scopeObj.isOffline = this.connection.isOffline;
    this.scopeObj.operState = this.connection.connections[0].operState;
    this.scopeObj.transportType = this.connection.transportType;
    this.scopeObj.result = this.connection.result;
    this.scopeObj.selectedSrcNode = this.data.srcNode.id;
    this.scopeObj.selectedDestNode = this.data.destNode.id;
    if (this.data.srcRI.operativeState === 'PREDELETED') {
      this.data.srcRI.name = this.data.srcRI.name + ' (PREDELETED)';
    }
    if (this.data.destRI.operativeState === 'PREDELETED') {
      this.data.destRI.name = this.data.destRI.name + ' (PREDELETED)';
    }
    this.scopeObj.selectedSrcRI = this.data.srcRI.id;
    this.scopeObj.selectedDestRI = this.data.destRI.id;
    this.options.srcNodes = [this.data.srcNode];
    this.options.destNodes = [this.data.destNode];
    this.options.srcRIs = [this.data.srcRI];
    this.options.destRIs = [this.data.destRI];
  }

  updateSrcNodeOptions(): void {
    if (this.scopeObj.selectedDestNode) {
      this.isDestNodeIsThirdParty = this.isSelectedNodeIsThirdParty(this.scopeObj.selectedDestNode);

      this.options.srcNodes = this.data.nodes.filter((node) => {
        return node.id !== this.scopeObj.selectedDestNode;
      });
    } else {
      this.options.srcNodes = this.data.nodes;
    }
  }

  updateDestNodeOptions(): void {
    if (this.scopeObj.selectedSrcNode) {
      this.isSrcNodeIsThirdParty = this.isSelectedNodeIsThirdParty(this.scopeObj.selectedSrcNode);

      this.options.destNodes = this.data.nodes.filter((node) => {
        return node.id !== this.scopeObj.selectedSrcNode;
      });
    } else {
      this.options.destNodes = this.data.nodes;
    }
  }

  updateSrcRIOptions(): void {
    if (this.scopeObj.selectedSrcNode) {
      this.options.srcRIs = this.data.routingInterface.filter((rI) => {
        return rI.nodeId === this.scopeObj.selectedSrcNode || rI.id === undefined;
      });
      this.scopeObj.selectedSrcRI = this.options.srcRIs.length > 0 ? this.options.srcRIs[0].id : null;
    } else {
      this.scopeObj.selectedSrcRI = null;
      this.options.srcRIs = [];
    }

  }

  updateDestRIOptions(): void {
    if (this.scopeObj.selectedDestNode) {
      this.options.destRIs = this.data.routingInterface.filter((rI) => {
        return rI.nodeId === this.scopeObj.selectedDestNode;
      });
      this.scopeObj.selectedDestRI = this.options.destRIs.length > 0 ? this.options.destRIs[0].id : null;
    } else {
      this.scopeObj.selectedDestRI = null;
      this.options.destRIs = [];
    }

  }

  updateEdgesName(): void {
    if (this.nodesAndRiSelected()) {
      this.scopeObj.srcNodeEdgeName = this.isSrcNodeIsThirdParty ? '' : this.generateSrcEdgeName();
      this.scopeObj.destNodeEdgeName =  this.isDestNodeIsThirdParty ? '' : this.generateDestEdgeName();
    } else {
      this.scopeObj.srcNodeEdgeName = '';
      this.scopeObj.destNodeEdgeName = '';
    }
  }

  private generateSrcEdgeName(): string {
    return `ARM_${this.scopeObj.selectedSrcNode}.${this.scopeObj.selectedSrcRI}_` +
        `${this.scopeObj.selectedDestNode}.${this.scopeObj.selectedDestRI}`;
  }

  private generateDestEdgeName(): string {
    return `ARM_${this.scopeObj.selectedDestNode}.${this.scopeObj.selectedDestRI}_` +
        `${this.scopeObj.selectedSrcNode}.${this.scopeObj.selectedSrcRI}`;
  }

  updateSrcNodeData(nodeId): void {
    this.selectedSrcNode = (nodeId !== null) ? this.data.nodes.find(node => node.id === nodeId) : null;
    this.isSrcNodeSupportsTeams = this.isNodeSupportsTeams(this.selectedSrcNode);
    this.updateSipGroupNameValidation();
  }

  updateDestNodeData(nodeId): void {
    this.selectedDestNode = (nodeId !== null) ? this.data.nodes.find(node => node.id === nodeId) : null;
    this.isDestNodeSupportsTeams = this.isNodeSupportsTeams(this.selectedDestNode);
    this.updateSipGroupNameValidation();
  }

  private isNodeSupportsTeams(node): boolean {
    return node && node.supportedFeatures && node.supportedFeatures.includes('TEAMS_CONNECTIONS');
  }

  private updateSipGroupNameValidation(): void {
    this.isSipGroupNameMandatory = !_.isNil(this.selectedDestNode) && !_.isNil(this.selectedSrcNode) &&
        ((this.selectedSrcNode.teamsRole === 'REMOTE' && this.selectedDestNode.teamsRole === 'PROXY') ||
            (this.selectedSrcNode.teamsRole === 'PROXY' && this.selectedDestNode.teamsRole === 'REMOTE'));
  }

  private updateIpProfilesAndMediaRealm(): void {
    this.updateSrcIpProfiles();
    this.updateDestIpProfiles();
    this.updateSrcMediaRealm();
    this.updateDestMediaRealm();
  }

  updateSrcIpProfiles(): void {
    if (_.isNil(this.data.ipProfiles) || this.isSrcNodeIsThirdParty) {
      this.options.srcIpProfiles = [];
      this.scopeObj.srcIpProfile = null;
      return;
    }

    this.options.srcIpProfiles = this.data.ipProfiles.filter(ipProfile => ipProfile.nodeId === this.scopeObj.selectedSrcNode);
    this.scopeObj.srcIpProfile = (this.options.srcIpProfiles && this.options.srcIpProfiles.length > 0) ?
        this.options.srcIpProfiles[0].id : null;
  }

  updateDestIpProfiles(): void {
    if (_.isNil(this.data.ipProfiles) || this.isDestNodeIsThirdParty) {
      this.options.destIpProfiles = [];
      this.scopeObj.destIpProfile = null;
      return;
    }

    this.options.destIpProfiles = this.data.ipProfiles.filter(ipProfile => ipProfile.nodeId === this.scopeObj.selectedDestNode);
    this.scopeObj.destIpProfile = (this.options.destIpProfiles && this.options.destIpProfiles.length > 0) ?
        this.options.destIpProfiles[0].id : null;
  }

  updateSrcMediaRealm(): void {
    if (_.isNil(this.data.mediaRealm) || this.isSrcNodeIsThirdParty) {
      this.options.srcMediaRealm = [];
      this.scopeObj.srcMediaRealm = null;
      return;
    }

    this.options.srcMediaRealm = this.data.mediaRealm.filter(mediaRealm => mediaRealm.nodeId === this.scopeObj.selectedSrcNode);
    this.scopeObj.srcMediaRealm = null;
  }

  updateDestMediaRealm(): void {
    if (_.isNil(this.data.mediaRealm) || this.isDestNodeIsThirdParty) {
      this.options.destMediaRealm = [];
      this.scopeObj.destMediaRealm = null;
      return;
    }

    this.options.destMediaRealm = this.data.mediaRealm.filter(mediaRealm => mediaRealm.nodeId === this.scopeObj.selectedDestNode);
    this.scopeObj.destMediaRealm = null;
  }

  private setDefaultIpProfile(): void {
    if (this.isSrcNodeSupportsTeams && this.isDestNodeSupportsTeams) {
      if (this.selectedSrcNode.teamsRole === 'PROXY' && this.selectedDestNode.teamsRole === 'REMOTE') {
        this.scopeObj.srcIpProfile = this.options.srcIpProfiles.find(p => p.name === 'ARM_IP_Profile_Proxy_To_Remote').id;
        this.scopeObj.destIpProfile = this.options.destIpProfiles.find(p => p.name === 'ARM_IP_Profile_Remote_To_Proxy').id;
      } else if (this.selectedSrcNode.teamsRole === 'REMOTE' && this.selectedDestNode.teamsRole === 'PROXY') {
        this.scopeObj.srcIpProfile = this.options.srcIpProfiles.find(p => p.name === 'ARM_IP_Profile_Remote_To_Proxy').id;
        this.scopeObj.destIpProfile = this.options.destIpProfiles.find(p => p.name === 'ARM_IP_Profile_Proxy_To_Remote').id;
      }
    }
  }

  private isSelectedNodeIsThirdParty(nodeId): boolean {
    const selectedNode = this.data.nodes.find(node => node.id === nodeId);

    return this.isThirdPartyNode(selectedNode);
  }

  private nodesAndRiSelected(): boolean {
    return this.scopeObj &&
        this.scopeObj.selectedSrcNode &&
        this.scopeObj.selectedSrcRI &&
        this.scopeObj.selectedDestNode &&
        this.scopeObj.selectedDestRI;
  }

  private constructConnectionForAdd(): void {
    this.connection.name = this.scopeObj.name;
    this.connection.transportType = this.scopeObj.transportType;
    this.connection.weight = this.scopeObj.weight;
    this.connection.connections = [];
    this.connection.connections.push(
      {
        srcNodeId: this.scopeObj.selectedSrcNode,
        destNodeId: this.scopeObj.selectedDestNode,
        srcRoutingInterface: this.scopeObj.selectedSrcRI,
        destRoutingInterface: this.scopeObj.selectedDestRI
      }
    );

    const selectedDestNodeObj = this.options.destNodes.find((node) => {
      return node.id === this.scopeObj.selectedDestNode;
    });
    if (selectedDestNodeObj.productType !== 'THIRD_PARTY') {
      this.connection.connections.push(
        {
          srcNodeId: this.scopeObj.selectedDestNode,
          destNodeId: this.scopeObj.selectedSrcNode,
          srcRoutingInterface: this.scopeObj.selectedDestRI,
          destRoutingInterface: this.scopeObj.selectedSrcRI
        }
      );
    }
  }

  private constructConnectionForEdit(): void {
    this.connection.name = this.scopeObj.name;
    this.connection.weight = this.scopeObj.weight;
    this.connection.transportType = this.scopeObj.transportType;
    this.connection.connections[0].operState = this.scopeObj.operState;
    this.connection.result = this.scopeObj.result;

    if (this.connection.type !== 'NODE_TO_THIRD_PARTY') {
      this.connection.connections[1].operState = this.connection.connections[0].operState;
    }
  }

  private isThirdPartyNode(node): boolean {
    return !_.isNil(node) && node.productType === 'THIRD_PARTY';
  }
}
